import React from 'react'
import { RequestAsync } from './AjaxRequest';

export const ObtenerBalanceAsync = async () => {
    let result = await RequestAsync("inicio/ObtenerBalance")
    return result;
}

export const ObtenerLibrosAsync = async () => {
    let result = await RequestAsync("inicio/ObtenerLibros")
    return result.payload;
}
export const InicioMobileAsync = async () => {
    let result = await RequestAsync("inicio/InicioMobile")
    return result;
}
export const ObtenerEstatusCuentaAsync = async () => {
    let result = await RequestAsync("inicio/ObtenerDatosUsuario")
    return result.payload;
}
export const ObtenerHistorialAsync = async (params) => {
    let result = await RequestAsync("inicio/ObtenerHistorial", params)
    return result;
}
export const OrdenesActivasAsync = async (params) => {
    let result = await RequestAsync("inicio/OrdenesActivas", params)
    return result;
}
export const OrdenesActivasTodasAsync = async (params) => {
    let result = await RequestAsync("inicio/OrdenesActivasTodas", params)
    return result;
}
export const ColocarOrdenAsync = async (params) => {
    let result = await RequestAsync("inicio/ColocarOrden", params)
    return result;
}
export const CancelarOrdenAsync = async (params) => {
    let result = await RequestAsync("inicio/CancelarOrden", params)
    return result;
}
export const ObtenerOrderIdAsync = async (oid) => {
    let result = await RequestAsync("inicio/ObtenerOrderId", { oid })
    return result;
}
export const OrdenMonitorAsync = async (orden) => {
    let result = await RequestAsync("inicio/OrdenMonitor", orden)
    return result;
}
export const OrdenMonitorObtenerAsync = async () => {
    let result = await RequestAsync("inicio/OrdenMonitorObtener")
    return result;
}
export const OrdenMonitorCancelarAsync = async (oid) => {
    let result = await RequestAsync("inicio/OrdenMonitorCancelar", { oid })
    return result;
}
export const ObtenerHistoricoMonedaAsync = async (Moneda, tipo) => {
    let result = await RequestAsync("inicio/ObtenerHistoricoMoneda", { Moneda, tipo })
    return result;
}

